import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" index element={<Layout />} />
      </Routes>
    </div>
  );
}

export default App;
